import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "bodyWrap2" }
const _hoisted_2 = { id: "companyLogoWrap" }
const _hoisted_3 = { style: {"border":"1px #DDD solid","height":"86.5%","margin":"0px 0px","margin-left":"5px"} }

import { onMounted,reactive } from 'vue'
import { ElTable,ElMessage  } from 'element-plus'
import $http from '../http/index'
import $helper from '../helper/helper'

// 产品需求
interface ProductRequirement{
    ID:string,
    TypeCode:string,
    GloryModel:string,
    Position:string,
    OE:string,
    RequirementQty:number,
    CarBrand:string,
    CarModel:string,
    Remark:string,
    AnonymityID:string,
    OtherBrandCodes:Array<PD_OtherBrandCodeEntity>,
    OtherBrand1:string,
    OtherBrand2:string,
    OtherBrand3:string,
    index:string,
    CarBrandShow:string,
    CarModelShow:string,
}

// 需求的额外信息
interface RequirementExtendInfo{
    requirementBrands:Array<string>
    addr:string //地址
    phoneNumber:string //联系方式
    email:string //邮箱
}

interface PD_OtherBrandCodeEntity{
    BrandsOther:string, // 品牌
    OtherCode:string,   // 编码
    GloryModel:string,  // 格莱利编码
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductRequirement',
  setup(__props) {

const emptyProductRequirement = {
    ID:'emptyProductRequirement',
    TypeCode:'',
    GloryModel:'+',
    Position:'',
    OE:'',
    RequirementQty:0,
    CarBrand:'',
    CarModel:'',
    Remark:'',
    AnonymityID:'',
    OtherBrandCodes:[],
    OtherBrand1:'',
    OtherBrand2:'',
    OtherBrand3:'',
    index:'',
    CarBrandShow:'',
    CarModelShow:'',
}

class RequirementQtyDTO{
    ID=''
    RequirementQty:number|null=null
    Remark=''
    constructor(id: string, requirementQty: number|null,remark:string) {  
        this.ID = id;  
        this.RequirementQty = requirementQty;  
        this.Remark =remark
    }
}

class InitData{
    anonymityID=''
    productRequirements:Array<ProductRequirement>=[]
    allOtherBrands:Array<string>=[] //全部其他品牌
    ProductRequirementOtherBrands:Array<string>=[] //当前需求的竞品品牌
    otherBrand1='' //其他品牌1
    otherBrand2='' //其他品牌2
    otherBrand3='' //其他品牌3
    companyLogoStyle = {
        height:'20px',
        width:'20px',
    }
    companyLogoUrl = require('../assets/images/glory.png')  
    baseCompanyLogoUrl = require('../assets/images/glory.png')  
    searchGloryModel=''
    allGloryModels:Array<string>=[]
    requirementExtendInfo:RequirementExtendInfo={
        requirementBrands:[],
        addr:'', //地址
        phoneNumber:'', //联系方式
        email:'' //邮箱
    }
    brands:Array<string>=[]//品牌
}

const data = reactive(new InitData());

const requirementExtendInfoCacheKey = 'requirementExtendInfoCacheKey';

const productRequirementShow =()=>{
    $http({
        url: `/API/Product/GetProductRequirement?anonymityID=${data.anonymityID}`,
        method: "GET",
    }).then(res=>{
        data.productRequirements = res.data;
        for(let i=0;i<data.productRequirements.length;i++){
            let productRequirement = data.productRequirements[i];
            productRequirement.index = `${i+1}`;
            for(let j=0;j<productRequirement.OtherBrandCodes.length;j++){
                let otherBrand=productRequirement.OtherBrandCodes[j];
                if(data.ProductRequirementOtherBrands.indexOf(otherBrand.BrandsOther)<0){
                    data.ProductRequirementOtherBrands.push(otherBrand.BrandsOther);
                }
            }
        }
        data.productRequirements.push(emptyProductRequirement)
        brandsOtherChange();
    })
}

onMounted(()=>{
    let anonymityID = localStorage.getItem("anonymityID");//匿名ID
    if(!anonymityID){
        anonymityID = $helper.createID();
        localStorage.setItem("anonymityID",anonymityID)
    }
    data.anonymityID = anonymityID;
    logoadapter();
    let requirementExtendInfo = window.localStorage.getItem(requirementExtendInfoCacheKey);
    if(requirementExtendInfo){
        data.requirementExtendInfo = JSON.parse(requirementExtendInfo);
    }
    $http({
        url: `/API/Product/GetOtherBrands`,
        method: "GET",
    }).then(res=>{
        data.allOtherBrands = res.data;
    })
    productRequirementShow()
    $http({
        url: `/API/Product/GetGloryModels`,
        method: "GET",
    }).then(res=>{
        data.allGloryModels = res.data;
    })
    //品牌装修数据获取的品牌
    const decoration = $helper.getBrandDecoration();
    if(decoration.BrandDatas && decoration.BrandDatas.toLowerCase().indexOf("glory")>-1){
        data.brands= ['GLORY','ASIMCO','PAXTON','CAC','BARBARO']
    }else if( decoration.BrandDatas && decoration.BrandDatas.toLowerCase().indexOf("glory")<0){
        const tempBrands = decoration.BrandDatas.split(',');
        data.brands=JSON.parse(JSON.stringify(tempBrands));
    }
        //公司图片logo
    if(decoration.ShowBrandPicture){
        data.companyLogoUrl = `${process.env.VUE_APP_BASE_API}/API/Product/GetPictute?folderId=${decoration.ShowBrandPicture}`
    }else{
        data.companyLogoUrl = data.baseCompanyLogoUrl;
    }
});

// 竞品品牌选中改变
const brandsOtherChange=()=>{
    for(let i=0;i<data.productRequirements.length;i++){
        let productRequirement = data.productRequirements[i];
        productRequirement.OtherBrand1 = '';
        let index1 = productRequirement.OtherBrandCodes.findIndex(c=>c.BrandsOther==data.otherBrand1);
        if(index1>-1){
            let otherBrand = productRequirement.OtherBrandCodes[index1];
            productRequirement.OtherBrand1 = `${otherBrand.BrandsOther}:${otherBrand.OtherCode}`;
        }
        productRequirement.OtherBrand2 = '';
        let index2 = productRequirement.OtherBrandCodes.findIndex(c=>c.BrandsOther==data.otherBrand2);
        if(index2>-1){
            let otherBrand = productRequirement.OtherBrandCodes[index2];
            productRequirement.OtherBrand2 = `${otherBrand.BrandsOther}:${otherBrand.OtherCode}`;
        }
        productRequirement.OtherBrand3 = '';
        let index3 = productRequirement.OtherBrandCodes.findIndex(c=>c.BrandsOther==data.otherBrand3);
        if(index3>-1){
            let otherBrand = productRequirement.OtherBrandCodes[index3];
            productRequirement.OtherBrand3 = `${otherBrand.BrandsOther}:${otherBrand.OtherCode}`;
        }
    }
}

// 需求量修改
const requirementQtyChagge=()=>{
    let dto:Array<RequirementQtyDTO> = [];
    for(let i=0;i<data.productRequirements.length;i++){
        let productRequirement = data.productRequirements[i];
        dto.push(new RequirementQtyDTO(productRequirement.ID,productRequirement.RequirementQty,''));
    }
    $http({
        url: `/API/Product/ChageRequirementQty`,
        method: "POST",
        data: {
            productRequirements:JSON.stringify(dto),
        }
    });
}

// 备注修改
const requirementRemarkChagge=()=>{
    let dto:Array<RequirementQtyDTO> = [];
    for(let i=0;i<data.productRequirements.length;i++){
        let productRequirement = data.productRequirements[i];
        dto.push(new RequirementQtyDTO(productRequirement.ID,null,productRequirement.Remark));
    }
    $http({
        url: `/API/Product/ChageRequirementRemark`,
        method: "POST",
        data: {
            productRequirements:JSON.stringify(dto),
        }
    });
}

// 移除产品需求
const removeProductRequirement=(ID:string)=>{
    $http({
        url: `/API/Product/RemoveProductRequirement`,
        method: "POST",
        data: {
            ID:ID,
            anonymityID:data.anonymityID
        }
    }).then(res=>{
        data.productRequirements = res.data;
        productRequirementShow();
    });
}

// 适配公司图标的位置和大小
const logoadapter = ()=>{ 
    let maxWidth = 100;
    let maxHeight = 50;
    let companyLogoWrap = document.getElementById('companyLogoWrap');
    let col_12 = document.getElementById('col12');
    if(companyLogoWrap!=null && col_12){
        maxWidth = companyLogoWrap.clientWidth;
        maxHeight = col_12.clientHeight ;
    }
    data.companyLogoStyle.width=`${maxWidth-10}px`; 
    data.companyLogoStyle.height=`${maxHeight-10}px`; 
}

const searchGloryModelInput = ()=>{
    let searchGloryModel = data.searchGloryModel.toLocaleUpperCase();
    let index = data.allGloryModels.findIndex(item=>item.toLocaleUpperCase()==searchGloryModel)
    if(index<0){
        ElMessage({
            showClose: true,
            message: '无此编码的产品',
            type: 'warning',
        })
        return;
    }
    $http({
        url: `/API/Product/AddProductRequirement`,
        method: "POST",
        data: {
            gloryModel:data.allGloryModels[index],
            anonymityID:data.anonymityID
        }
    }).then(() => {
        productRequirementShow();
        data.searchGloryModel=''
    });
}

const requirementBrandsChange=()=>{
    let requirementExtendInfo = JSON.stringify(data.requirementExtendInfo);
    window.localStorage.setItem("requirementExtendInfoCacheKey",requirementExtendInfo)
}

// 导出
const printProductRequirement=()=>{
    let param = {
        AnonymityID:data.anonymityID,
        RequirementBrands:data.requirementExtendInfo.requirementBrands,
        Addr:data.requirementExtendInfo.addr,
        PhoneNumber:data.requirementExtendInfo.phoneNumber,
        Email:data.requirementExtendInfo.email,
        OtherBrand1:data.otherBrand1,
        OtherBrand2:data.otherBrand2,
        OtherBrand3:data.otherBrand3,
    };
    $http({
        url: `/API/Product/PrintProductRequirement`,
        method: "POST",
        data: {
            dto:JSON.stringify(param)
        }
    }).then(res => {
        let link = document.createElement("a");
        link.style.display="none";
        link.href = `${process.env.VUE_APP_BASE_API}/API/Product/PrintProductRequirementFileDownload?cacheKey=${res.data}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 6,
          id: "col11"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_image, {
                style: _normalizeStyle(data.companyLogoStyle),
                src: data.companyLogoUrl,
                fit: "contain"
              }, null, 8, ["style", "src"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 6,
          id: "col12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "headInfoRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"padding-top":"5px","padding-bottom":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('产品需求清单')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "headInfoRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: data.requirementExtendInfo.requirementBrands,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.requirementExtendInfo.requirementBrands) = $event)),
                      placeholder: _unref($helper).lan('请选择需求品牌'),
                      multiple: "",
                      "collapse-tags": "",
                      onChange: requirementBrandsChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.brands, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "headInfoRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 4,
                  style: {"text-align":"right","padding-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('地址')) + "：", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref($helper).lan('输入'),
                      modelValue: data.requirementExtendInfo.addr,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.requirementExtendInfo.addr) = $event)),
                      onChange: requirementBrandsChange
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "headInfoRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 4,
                  style: {"text-align":"right","padding-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('联系方式')) + "：", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref($helper).lan('输入'),
                      modelValue: data.requirementExtendInfo.phoneNumber,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.requirementExtendInfo.phoneNumber) = $event)),
                      onChange: requirementBrandsChange
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 4,
                  style: {"text-align":"right","padding-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('邮箱')) + "：", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: _unref($helper).lan('输入'),
                      modelValue: data.requirementExtendInfo.email,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.requirementExtendInfo.email) = $event)),
                      onChange: requirementBrandsChange
                    }, null, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_link, {
                underline: false,
                style: {"width":"100%","text-align":"center","display":"flex","height":"74px"},
                onClick: printProductRequirement
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h1", null, _toDisplayString(_unref($helper).lan('导出')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ElTable), {
      data: data.productRequirements,
      border: true,
      "show-overflow-tooltip": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          property: "index",
          label: _unref($helper).lan('序号'),
          width: "40",
          "label-class-name": "customLabelClassName"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "TypeCode",
          label: _unref($helper).lan('产品类别'),
          width: "100",
          "label-class-name": "customLabelClassName"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "GloryModel",
          label: _unref($helper).lan('型号'),
          width: "80",
          "label-class-name": "customLabelClassName",
          "class-name": "customColumnClassName"
        }, {
          default: _withCtx((scope) => [
            _withDirectives(_createElementVNode("span", null, _toDisplayString(scope.row.GloryModel), 513), [
              [_vShow, scope.row.ID!='emptyProductRequirement']
            ]),
            _withDirectives(_createVNode(_component_el_input, {
              modelValue: data.searchGloryModel,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.searchGloryModel) = $event)),
              placeholder: _unref($helper).lan('按型号添加'),
              onKeydown: _withKeys(searchGloryModelInput, ["enter"])
            }, null, 8, ["modelValue", "placeholder", "onKeydown"]), [
              [_vShow, scope.row.ID =='emptyProductRequirement']
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "Position",
          label: _unref($helper).lan('位置'),
          width: "75",
          "label-class-name": "customLabelClassName"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "OE",
          label: "OE",
          width: "120",
          "label-class-name": "customLabelClassName"
        }),
        _createVNode(_component_el_table_column, {
          property: "OtherBrand1",
          width: "120",
          "label-class-name": "customLabelClassName"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.otherBrand1,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.otherBrand1) = $event)),
              placeholder: _unref($helper).lan('选择品牌'),
              onChange: brandsOtherChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.ProductRequirementOtherBrands, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          property: "OtherBrand2",
          width: "120",
          "label-class-name": "customLabelClassName"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.otherBrand2,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.otherBrand2) = $event)),
              placeholder: _unref($helper).lan('选择品牌'),
              onChange: brandsOtherChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.ProductRequirementOtherBrands, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          property: "OtherBrand3",
          width: "120",
          "label-class-name": "customLabelClassName"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.otherBrand3,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.otherBrand3) = $event)),
              placeholder: _unref($helper).lan('选择品牌'),
              onChange: brandsOtherChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.ProductRequirementOtherBrands, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          property: "RequirementQty",
          label: _unref($helper).lan('需求量'),
          width: "70",
          "label-class-name": "customLabelClassName",
          "class-name": "customColumnClassName"
        }, {
          default: _withCtx((scope) => [
            _withDirectives(_createVNode(_component_el_input, {
              modelValue: scope.row.RequirementQty,
              "onUpdate:modelValue": ($event: any) => ((scope.row.RequirementQty) = $event),
              placeholder: _unref($helper).lan('请填写'),
              type: "number",
              onChange: requirementQtyChagge
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]), [
              [_vShow, scope.row.ID!='emptyProductRequirement']
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "CarBrandShow",
          label: _unref($helper).lan('车系品牌'),
          width: "90",
          "label-class-name": "customLabelClassName"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "CarModelShow",
          label: _unref($helper).lan('主要车型信息'),
          width: "200",
          "label-class-name": "customLabelClassName"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "Remark",
          label: _unref($helper).lan('备注'),
          width: "65",
          "label-class-name": "customLabelClassName",
          "class-name": "customColumnClassName"
        }, {
          default: _withCtx((scope) => [
            _withDirectives(_createVNode(_component_el_input, {
              modelValue: scope.row.Remark,
              "onUpdate:modelValue": ($event: any) => ((scope.row.Remark) = $event),
              placeholder: _unref($helper).lan('请填写'),
              onChange: requirementRemarkChagge
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]), [
              [_vShow, scope.row.ID!='emptyProductRequirement']
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          property: "Opereate",
          label: " ",
          width: "50",
          "label-class-name": "customLabelClassName"
        }, {
          default: _withCtx((scope) => [
            _withDirectives(_createVNode(_component_el_link, {
              underline: false,
              onClick: ($event: any) => (removeProductRequirement(scope.row.ID))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DeleteFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_vShow, scope.row.ID!='emptyProductRequirement']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})